import { apiClient } from '@/lib/api/client';
import type { ApiKey, GenerateApiKeyPayload, GeneratedApiKey, DeleteApiKeyResult } from '../types/apikey.types';

export const apikeyService = {
  async getApiKeys(): Promise<ApiKey[]> {
    const response = await apiClient.get('/apikeys');
    return response.data?.apiKeys || [];
  },

  async generateApiKey(payload: GenerateApiKeyPayload): Promise<GeneratedApiKey> {
    const response = await apiClient.post('/apikeys', payload);
    return response.data.apiKey;
  },

  async deleteApiKey(id: string): Promise<DeleteApiKeyResult> {
    const response = await apiClient.delete(`/apikeys/${id}`);
    return response.data;
  },
};
